import { updateCart } from "./cart";

export default (initial) => ({
    ...initial,

    toggleGiftMessage() {
        if (!this.includeGiftMessage) {
            this.to = "";
            this.from = "";
            this.message = "";
            this.save();
        }
    },

    toggleNotes() {
        if (!this.includeNotes) {
            this.notes = "";
            this.save();
        }
    },

    // `run` and `advance` come from the parent SinglePageCheckout scope.
    continueGifting() {
        return this.run("gifting", async () => {
            await this.save();
            this.advance("gifting");
        });
    },

    // `track` comes from the parent SinglePageCheckout scope.
    save() {
        return this.track(
            updateCart({
                fields: {
                    orderGiftMessageTo: this.to,
                    orderGiftMessageFrom: this.from,
                    orderGiftMessage: this.message,
                    orderAdditionalNotes: this.notes,
                },
            }),
        ).catch((e) => console.error(e));
    },
});
